import { Component, inject, signal } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDialog } from '@angular/material/dialog';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { MOCK_FORM_FIELDS } from '@demo/data/demo-form-builder.const';
import { DemoFormBuilderService } from '@demo/module-definition/demo-form-builder/demo-form-builder.service';
import { GridFormViewComponent } from '@module-definition/form/grid-form-view/grid-form-view.component';
import { GridFormComponent } from '@module-definition/form/grid-form/grid-form.component';
import { FormBuilderModalComponent } from '@module-instance/form-builder-modal/form-builder-modal.component';
import { CipoControl, CipoFieldConfig, CipoForm } from '@shared/components/fields/common';
import { UserService } from '@shared/services';

@Component({
  selector: 'app-demo-form-builder',
  templateUrl: './demo-form-builder.component.html',
  imports: [GridFormComponent, MatButtonToggleModule, FlexLayoutModule, MatButtonModule, GridFormViewComponent],
})
export class DemoFormBuilderComponent {
  dialog = inject(MatDialog);
  fb = inject(FormBuilder);
  demoService = inject(DemoFormBuilderService);
  userService = inject(UserService);

  items = signal(MOCK_FORM_FIELDS);
  form: CipoForm = this.fb.group({});
  fieldsData = signal<Record<string, CipoFieldConfig>>({});
  editMode = signal(true);
  constructor() {
    this.demoService.getFormData().subscribe(fields => {
      const fieldsData: Record<string, CipoFieldConfig> = {};
      fields.forEach(item => {
        const control = new CipoControl(item.value, item.fieldOptions);
        this.form.addControl(item.id, control);
        fieldsData[item.id] = item.fieldOptions;
      });
      this.fieldsData.set(fieldsData);
    });
  }

  logItems() {
    console.log(this.form.value);
  }

  openBuilder() {
    this.dialog.open(FormBuilderModalComponent, {
      panelClass: ['cipo-dialog', 'classic', 'cipo--height--full'],
      ...this.userService.getResponsiveDialogSize().xl,
    });
  }
}
